<template>
  <div>
    <v-btn
      v-for="(item, i) in items.slice(0, large ? items.length : 3)"
      :key="i"
      :title="item.name"
      fab
      class="ma-2"
      :large="large"
      color="info"
      @click="changeLang(item.name)"
    >
      <v-icon
        size="100%"
        dark
        v-text="item.icon"
      />
    </v-btn>
  </div>
</template>

<script>
export default {
  props: {
    large: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    items: [
      {
        name: 'Russian',
        icon: 'ru'
      },
      {
        name: 'English',
        icon: 'en'
      },
      {
        name: 'Ukraine',
        icon: 'uk'
      }
    ]
  }),
  methods: {
    changeLang (language) {
      let lang = language.slice(0, 2).toLowerCase()
      this.$store.dispatch('setLanguage', lang).then(this.$i18n.locale = this.$store.getters.getLanguage)
    }
  }
}
</script>
